import React, { useContext, useState, useEffect, useRef, lazy, Suspense } from 'react'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faWrench, faIndustry, faSearch, faUserPlus, faQuestionCircle, faShoppingCart, faEye, faHome, faChevronUp, faChevronDown, faTrophy } from '@fortawesome/free-solid-svg-icons';
import { Link, useLocation, useNavigate } from 'react-router-dom'
import TopAlert from './headerAlertModal'
import Context from '../../setup/context'
import Loader from '../../pageComponents/_common/loader'
import { NavigationItemContainer, DropdownMenu, DropdownMenuItem, MyAccountDropdownMenu, ImgDropdownMenu, ShopImgDropdownMenu, BrandDropdownMenu, SolutionsDropdownMenuContainer, ServicesDropdownMenuContainer } from 'pageComponents/_common/dropdown-menu/DropdownMenu'
import { buildSearchString, onWindowResize, useDebounceValue } from '../../pageComponents/_common/helpers/generalHelperFunctions'
import ShoppingCartPreview from '../../pageComponents/ShoppingCart/uiComponents/ShoppingCartPreview';
import { useQuery } from '@apollo/client'
import { GET_ROOT_CATEGORIES_HEADER } from 'setup/providerGQL'
import { Button, Menu } from '@mui/material'
import queryString from 'query-string'
import HidePrint from '../../pageComponents/_common/HidePrint'
import OrderDetailModal from '../modals/orderDetailMenu'
import MenuVisibility from 'pageComponents/_common/dropdown-menu/MenuVisibility'
import { useAuth } from 'react-oidc-context'
import { headerTabs } from './headerTabs'
import { servicesSubItems, industriesSubItems, brandsSubItems, contactSubItems, resourcesSubItems, shopSubItems, solutionsSubItems, aboutSubItems } from './headerTabs'

import FeedbackForm from './feedbackForm'
import ImmediateSearch from './immediateSearch'
import { gtag } from 'ga-gtag';

const AdvancedSearch = lazy(() => import('../modals/AdvancedSearch'))
const ImpersonationSearch = lazy(() => import('./impersonationSearch'))
const NotesModal = lazy(() => import('../modals/Notes'))
const BrandsDropdownMenu = lazy(() => import('pageComponents/_common/dropdown-menu/BrandsDropdownMenu'))
const ShopDropdownMenu = lazy(() => import('pageComponents/_common/dropdown-menu/ShopDropdownMenu'))
const AboutDropdownMenu = lazy(() => import('pageComponents/_common/dropdown-menu/AboutDropdownMenu'))
//const ContactDropdownMenu = lazy(() => import('pageComponents/_common/dropdown-menu/ContactDropdownMenu'))
const ResourcesDropdownMenu = lazy(() => import('pageComponents/_common/dropdown-menu/ResourcesDropdownMenu'))
const SolutionsDropdownMenu = lazy(() => import('pageComponents/_common/dropdown-menu/SolutionDropdownMenu'))
const SolutionsMenuResponsive = lazy(() => import('pageComponents/_common/dropdown-menu/SolutionsMenuResponsive'))
const ServicesDropDownMenu = lazy(() => import('pageComponents/_common/dropdown-menu/ServicesDropdownMenu'))
const ServicesMenuResponsive = lazy(() => import('pageComponents/_common/dropdown-menu/ServicesMenuResponsive'))

const Nav = styled.div`
	position: ${props => props.location.pathname === '/search' && window.innerWidth < 750 ? 'relative' : '-webkit-sticky'};
	position: ${props => props.location.pathname === '/search' && window.innerWidth < 750 ? 'relative' : (props.disableSticky ? 'inherit' : 'sticky')};
	top: 0;
    align-self: flex-start;
    z-index: 5;
    width: 100%;
`
const NavTop = styled.div`
	display: flex;
	margin: 0 auto;
	padding: 2px 0;
	width: 100%;
	background-color: #535353;
	justify-content: center;
`
const NavBottom = styled.div`
	margin: 0 auto;
	width: 100%;
	background-color: white;
	box-shadow: 0px 3px 4px #dadada;
	min-height: 48px;
`
//The idea of the Gutter and its nested hanger div is to construct a full-width
// but zero-height div that can be relatively positioned, then stuff an absolutely
// positioned div inside that which will anchor to it and "float"
const NavGutter = styled.div`
	position: relative;
	height: 0;
`
const NavContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	height: 100%;
	align-items: center;
`

const LinkContainer = styled.div`
	display: flex;
	align-items: center;
	flex: 1;
	color: black;
	font-size: 14px;
	font-weight: 500;
	@media (max-width: 769px) {
		justify-content: flex-end;
	}
`
const InputSearch = styled.input`
	width: 260px;
	height: 40px;
	font-size: 15px;
	border-color: #dadada;
	border-top: 1px #dadada solid;
	border-left: 1px #dadada solid;
	border-bottom: 1px #e7e7e7 solid;
	border-right: 0px;
	padding: 0 8px;
	&:focus{
		border-top: 1px #b4b4b4 solid;
		border-left: 1px #b4b4b4 solid;
		border-bottom: 1px #b4b4b4 solid;
	}
	@media(max-width: 769px){
		width: 90%;
	}
	@media (max-width: 365px) {
		width: 215px;
	}
`
const ButtonSearch = styled.button`
	width: 50px;
	height: 40px;
	background-image: linear-gradient(to top left, ${props => props.theme.mainColorBlend},  ${props => props.theme.mainColor});
	color: ${props => props.theme.buttonForegroundColor};
	font-weight: 500;
	border: 0;
	font-size: 14px;
	border-radius: 0 5px 5px 0;
`
const ButtonSearchType = styled.button`
	width: 40px;
	height: 40px;
	background-image: linear-gradient(to top left, #404040, #272727);
	border-radius: 3px 0px 0 3px;
	color: white;
	font-weight: 500;
	border: 0;
	font-size: 14px;
`
const Row = styled.div`
	display: flex;
	align-items: center;
	@media(max-width: 769px){
		width: 100%;
		margin-top: 2px;
	}
	@media (max-width: 440px) {
		width: 100%;
		margin: 5px 0;
	}
`
const ReverseNavContainer = styled.div`
	display: flex;
	flex-direction: row-reverse;
	flex-wrap: wrap;
	height: 100%;
	width: 100%;
	flex-basis: space-between;
	@media (max-width: 769px) {
    	justify-content: center;
  }
	@media (max-width: 440px) {
    	justify-content: center;
  }
`
const AccountSectionRow = styled.div`
	display: flex;
	flex-wrap: wrap;
`
const UserNameRow = styled.div`
	display: flex;
	flex-wrap: wrap;
	flex-grow: 1;
	align-items: center;
		@media (max-width: 808px) {
		justify-content: center;
	}
		@media (max-width: 440px) {
		justify-content: center;
	}
`
const Puser = styled.p`
	background-image: linear-gradient(to top left, #404040, #333);
	color: #f3f3f3;
	font-size: 11px;
	margin: 0;
	padding: 3px;
	border-radius: 30px;
	font-weight: 600;
	margin-bottom: 5px;
	margin-top: 5px;
`
const PeUser = styled(Puser)`
	background-image: linear-gradient(to top left, #328efc, #133752);
`
const P = styled.p`
	cursor: pointer;
	color: #f3f3f3;
	margin: 0;
	font-size: 14px;
	font-weight: 600;
	padding: 0 5px;
	white-space: nowrap;
`
const A = styled.a`
	cursor: pointer;
	color: #f3f3f3;
	margin: 0;
	font-size: 14px;
	font-weight: 600;
	padding: 0 5px;
	white-space: nowrap;
	&:hover {
		color: #f3f3f3;
	}
`

const AImpersonated = styled(A)`
	font-size: 12px;
`

const Aphone = styled(P)`
	margin: 0;
	color: white;
	white-space: nowrap;
`
const CancelImpersonationButton = styled.button`
	width: 20px;
	background-image: linear-gradient(to top left, ${props => props.theme.mainColorBlend},  ${props => props.theme.mainColor});
	color: ${props => props.theme.buttonForegroundColor};
	font-weight: 500;
	border: 0;
	font-size: 12px;
	border-radius: 5px;
	&:hover {
		color: #f3f3f3;
	}
`
const GrayDiv = styled.div`
	color: gray;
`
const GreenDiv = styled.div`
	color: limegreen;
`
const SearchBarRow = styled.div`
 	display: flex;
 	flex: 1;
 	justify-content: flex-end;
	@media(max-width: 769px){
		justify-content: center;
		margin: 5px 0 5px 0;
	}
 	@media (max-width: 755px) {
 		justify-content: center;
		margin-bottom: 5px;
	}
`

const LoaderContainer = styled.div`
    height: 20px;
    width: 58px;
    position: relative;
    top: -20px;
`
const AirlineLogoImg = styled.img`
    margin-left: 5px;
`
const ContactUsButton = styled.button`
    border: 0;
    padding: 5px 15px;
    border-radius: 20px;
    background-color: #007bff;
	color: white;
	margin-left: 10px;
`
const ContactUsLink = styled.a`
	color: white;
	text-decoration: none;
	font-weight: 500;
	&:hover{
		color: white;
		text-decoration: none;
	}
`
const Div = styled.div`
	display: flex;
	@media (max-width: 440px) {
    	display: none;
  	}
`
const CartWrapper = styled.div`
  position: relative;

  @media (hover: hover) and (pointer: fine) {
    &:hover .dropdown {
      opacity: 1;
      visibility: visible;
      transform: translateY(0);
    }
  }
`;

const Dropdown = styled.div`
  position: absolute;
  right: 0;
  top: 100%;
  width: 30vw;
  max-height: 70vh;        /* Limit height */
  background: white;
  border: 1px solid #ddd;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  padding: 10px 0;
  margin: 10px;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition: all 0.3s ease;
  z-index: 999;
  scrollbar-width: thin;     /* Optional: Firefox scrollbar style */
  scrollbar-color: #ccc transparent; /* Optional: Firefox scrollbar color */
  display: flex;           /* Make it a flex container */
  flex-direction: column;  /* Arrange items vertically */
`;

// Start of hamburger menu styles

const MobileMenuOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.33);
  z-index: 2000;
  transition: background 0.2s;
`;

const MobileSlideoutMenu = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  height: 100vh;
  width: 65vw;
  max-width: 350px;
  background-color: rgb(83, 83, 83);
  color: white;
  z-index: 2001;
  box-shadow: -2px 0 10px rgba(0,0,0,0.25);
  display: flex;
  flex-direction: column;
  padding: 24px 18px 12px 24px;
  animation: slideIn 0.3s cubic-bezier(.61,.01,.97,.58);

  & button {
    color: white;
	 
}
	 & ul li a {
    color: white;
  }
  @keyframes slideIn {
    from { transform: translateX(100%); }
    to   { transform: translateX(0); }
  }
`;

const MobileMenuCloseButton = styled.button`
  background: none;
  border: none;
  font-size: 2rem;
  position: absolute;
  top: 16px;
  right: 7px;
  color: #555;
  cursor: pointer;
  &:hover {
    color: #000;
  }
`;

const MobileMenuList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 48px 0 0 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const MobileMenuItem = styled.li`
  font-size: 1.1rem;
  font-weight: 500;

  & li{
    // border-bottom: 2px solid gray;
    padding-bottom: 10px;
  }
  & > a {
    color: #222;
    text-decoration: none;
    &:hover {
      color: #0066cc;
    }
  }
`;
const MobileMenusubItems = styled.li`
  font-size: 1.1rem;
  font-weight: 500;
  & > a {
    color: #222;
    text-decoration: none;
    &:hover {
      color: #0066cc;
    }
  }
`;
const SubItemUl = styled.ul`
	padding-left: 0;
	list-style: none;
	font-size: 14px;
	margin-top: 8px;
	overflow-y: auto;
	max-height: ${({ isScrollable }) => (isScrollable ? '250px' : 'auto')};
	& li {
		padding: 8px 0 8px 0;
		border-bottom: 2px solid #3c4142;
		&:hover {
		color: #0066cc;
		}
	}
`;

// end of hamburger menu styles

const PTerm = styled.p`
	color: white;
	font-weight: 500;
	margin-bottom: 0;
	margin-left: 15px;
	font-size: 12px;
`
function ContactUs() {
	return <ContactUsButton><ContactUsLink href="/pages/contact/contact-us">Contact Us</ContactUsLink></ContactUsButton>;
}

function ToMenuItem({ label, to, isExternalLink }) {
	return <DropdownMenuItem key={label} to={to} isExternalLink={isExternalLink}>{label}</DropdownMenuItem>;
}

function AccountSection({ auth, context, location, navigate }) {
	const [isOrderLookupOpen, setIsOrderLookupOpen] = useState(false);

	return <AccountSectionRow>
		<Row style={{ justifyContent: 'center' }}>
			<Div>
				<FontAwesomeIcon icon="phone-alt" color="white" />
				<Aphone href="tel:+18009997378">800-999-7378</Aphone>
			</Div>
		</Row>

		<Row style={{ justifyContent: 'center' }}>
			{auth.isAuthenticated
				? <P onClick={() => void context.signOut() /*Note, sign out isn't complete until the user is redirected back to post_logout_url, in oidc-settings.js */}>Sign Out</P>
				: <P onClick={() => void context.signIn(location?.pathname)}>Sign In</P>
			}

			<P>|</P>

			{auth.isAuthenticated
				? <P onClick={() => navigate('/account/orders')}>My Orders</P>
				: window.innerWidth > 1024 ?
					<P onClick={() => setIsOrderLookupOpen(true)}>Order Lookup</P> :
					<P onClick={() => { navigate("/mobile/orderlookup") }}>Order Lookup</P>
			}

			<OrderDetailModal onClick={() => setIsOrderLookupOpen(true)} open={isOrderLookupOpen} hide={setIsOrderLookupOpen}></OrderDetailModal>

			<P>|</P>

			{auth.isAuthenticated
				? <MyAccountDropdown />
				: <A href="/signup">Request Account</A>
			}

			<P>|</P>

			{context.cart && !context.cartLoading && (
				<CartWrapper>
					<Link to='/cart' style={{ textDecoration: 'none' }}>
						<P>Cart({context.cart.length})</P>
					</Link>
					{/* <Link to='/cart' style={{ textDecoration: 'none' }}> */}

					{context.cart.length > 0 && (
						<Dropdown className="dropdown">
							<ShoppingCartPreview />

						</Dropdown>
					)}
				</CartWrapper>
			)}
			{(!context.cart || context.cartLoading) && (
				<LoaderContainer>
					<Loader />
				</LoaderContainer>
			)}
		</Row>
	</AccountSectionRow>;
}

function MyAccountDropdown() {
	const [showMyAccountDropdown, setShowMyAccountDropdown] = useState(false);

	return <div
		id="myAccount"
		onMouseEnter={() => setShowMyAccountDropdown(true)}
		onMouseLeave={() => setShowMyAccountDropdown(false)}
	>
		<Link to="/account/dashboard" style={{ textDecoration: 'none' }}>
			<P id="myAccount">My Account</P>
		</Link>

		<MyAccountDropdownMenu className={showMyAccountDropdown ? 'visible' : ''}>
			<DropdownMenuItem to="/account/shopping-lists">Shopping Lists</DropdownMenuItem>
			<DropdownMenuItem to="/pages/contact/contact-us">Request for Quote</DropdownMenuItem>
			<DropdownMenuItem to="/account/dashboard">Account Profile</DropdownMenuItem>
			<DropdownMenuItem to="/account/invoices">Invoices</DropdownMenuItem>
			<DropdownMenuItem to="/account/orders">Orders</DropdownMenuItem>
			<DropdownMenuItem to="/account/open-orders-report">Open Orders Report</DropdownMenuItem>
			<DropdownMenuItem to="/account/quotes">Open Quotes</DropdownMenuItem>
			<DropdownMenuItem to="/account/my-ordered-items">Item Purchase History</DropdownMenuItem>
		</MyAccountDropdownMenu>
	</div>
}

function SearchBar({ context, location, navigate }) {
	const [searchTerm, setSearchTerm] = useState('');
	const debouncedSearchTerm = useDebounceValue(searchTerm);
	const [searchAsCustomer, setSearchAsCustomer] = useState(false);

	//When user presses enter, perform full search
	const handleSearch = () => {
		const parsedQueryString = queryString.parse(location.search);
		const search = searchTerm?.length ? searchTerm : parsedQueryString.searchTerm;
		const hasNonWebChanged = searchAsCustomer !== !!parsedQueryString.nonweb;
		if (search?.length || hasNonWebChanged) navigate(buildSearchString({ searchTerm: search, nonweb: searchAsCustomer }));
	};
	//When user just types, show the immediate search component

	const handleKeyPress = e => e.key === 'Enter' && handleSearch();

	const searchPlaceholder = searchAsCustomer ? '[Non-web Included] Search by Part # or Keyword' : 'Search by Part # or Keyword';

	return <SearchBarRow>
		{context.userInfo?.isAirlineEmployee && (
			<ButtonSearchType onClick={() => setSearchAsCustomer(!searchAsCustomer)}>
				{searchAsCustomer ? <GreenDiv>NW</GreenDiv> : <GrayDiv>NW</GrayDiv>}
			</ButtonSearchType>
		)}

		<InputSearch
			value={searchTerm}
			placeholder={searchPlaceholder}
			onChange={e => setSearchTerm(e.target.value)}
			onKeyPress={handleKeyPress}
		/>

		<ButtonSearch onClick={handleSearch} aria-label="Search icon">
			<FontAwesomeIcon icon="search" color="#f6f6f6" size="lg" />
		</ButtonSearch>

		<ImmediateSearch debouncedSearchTerm={debouncedSearchTerm} nonWebMode={searchAsCustomer} doRegularSearch={handleSearch} />

	</SearchBarRow>;
}

function UserNameSection({ context, location, setShowAdvancedModal }) {
	const { userInfo, impersonatedCompanyInfo, cancelImpersonation } = context;
	const [isMobile, setIsMobile] = useState(window.innerWidth < 769);

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth < 769);
		};

		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	useEffect(() => {
		if (userInfo?.isWebUser) {
			if (typeof gtag === 'function') {
				gtag('event', 'login', {
					method: 'site-login'
				});
				gtag('set', 'user_properties', {
					is_logged_in: true,
					user_id: userInfo?.webUserId,
				});
			}
		}
	}, [userInfo?.isWebUser]);

	if (userInfo && !impersonatedCompanyInfo) {
		return (
			<UserNameRow>
				{(!isMobile || userInfo.isAirlineEngineerUser) && (
					<Puser>
						Hello, {userInfo.preferredName} ({userInfo.companyName} - {userInfo.companyId})
					</Puser>
				)}

				{userInfo.isAirlineEngineerUser && (
					<Suspense fallback={<Loader />}>
						<ImpersonationSearch setShowAdvancedModal={setShowAdvancedModal} />
					</Suspense>
				)}
			</UserNameRow>
		);
	} else if ((userInfo && impersonatedCompanyInfo)) {
		return (
			<UserNameRow>
				<PeUser>
					<AImpersonated target='_' href={`${process.env.REACT_APP_WEB_CONNECT_URL}/common/CustomerDetails.aspx?CustomerID=${impersonatedCompanyInfo.CustomerIdP21}&CompanyID=AIRLINE`}>
						<FontAwesomeIcon icon="user-circle" color="#f3f3f3" style={{ marginRight: "2px" }} />
						{impersonatedCompanyInfo.CustomerName} - {impersonatedCompanyInfo.CustomerIdP21} [Impersonating]
					</AImpersonated>
					<CancelImpersonationButton title="End Impersonation" onClick={() => cancelImpersonation(location?.pathname)}>
						<FontAwesomeIcon icon="times" color="white" />
					</CancelImpersonationButton>
				</PeUser>

				<Suspense fallback={<Loader />}>
					<ImpersonationSearch setShowAdvancedModal={setShowAdvancedModal} />
				</Suspense>
				{impersonatedCompanyInfo?.CustomerMandatoryNotes && (
					<Suspense fallback={<Loader />}>
						<NotesModal notes={impersonatedCompanyInfo.CustomerMandatoryNotes} />
					</Suspense>
				)}
				{impersonatedCompanyInfo.Terms && (
					<div><PTerm>Terms: {impersonatedCompanyInfo.Terms || 'Credit Card'}</PTerm></div>

				)}
			</UserNameRow>
		);
	} else {
		return null;
	}
}

export default function HeaderComponent(props) {
	const tabContainerRef = useRef(null);
	const tabRefs = useRef([]);
	const location = useLocation();
	const navigate = useNavigate();
	const [categories, setCategories] = useState([]);
	const tabDeclaration = headerTabs(categories);
	const [visibleTabCount, setVisibleTabCount] = useState(tabDeclaration.length);
	const [overflowMenu, setOverflowMenu] = useState(null);
	const [showAdvancedModal, setShowAdvancedModal] = useState(false);
	const btnRef = useRef()
	const context = useContext(Context);
	const [openDropDownMenu, setOpenDropDownMenu] = useState({});
	const auth = useAuth();
	const [isSmallScreen, setIsSmallScreen] = useState(false);
	const [isMobile, setIsMobile] = useState(false);
	const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
	const [subItemOpenTab, setSubItemOpenTab] = useState(null);

	const checkScreenSize = () => {
		setIsSmallScreen(window.innerWidth < 1200);
		setIsMobile(window.innerWidth < 769);
	};

	useEffect(() => {
		checkScreenSize(); // Check initially
		window.addEventListener('resize', checkScreenSize);
		return () => {
			window.removeEventListener('resize', checkScreenSize);
		};
	}, []);

	useQuery(GET_ROOT_CATEGORIES_HEADER, {
		onCompleted: data => {
			setCategories(data.getAllRootCategories);
		}
	});
	const calculateTabs = () => {
		const containerRight = tabContainerRef.current && tabContainerRef.current.getBoundingClientRect().right
		const contactUsButtonWidth = 112;
		const widthOfTheComponentsToTheRightOfTheTabs = containerRight < 724 ? 70 : 420 + contactUsButtonWidth; //SearchBar wraps at < 724
		const count = tabRefs.current.reduce((count, tabRight) => {
			if (tabRight <= (containerRight - widthOfTheComponentsToTheRightOfTheTabs)) {
				count += 1
			}
			return count
		}, 0);
		setVisibleTabCount(count);
	};

	useEffect(() => {
		calculateTabs();
		return onWindowResize(calculateTabs);
	}, []);

	const setTabRef = idx => ref => {
		const right = ref && ref.getBoundingClientRect().right;
		if (right) tabRefs.current[idx] = right;
	};
	const toggleTab = (tabName) =>
		setSubItemOpenTab(prev => (prev === tabName ? null : tabName));

	function ToMenu({ image, label, to, subItems, isExternalLink }, idx) {
		if (window.innerWidth > 1200) {
			if (label === 'Brands') {
				return (
					<MenuVisibility {...{ setOpenDropDownMenu, name: "brands" }} key={label}>
						<NavigationItemContainer to={to} isExternalLink={isExternalLink} text={label} key={label} image={image} ref={setTabRef(idx)}>
							<BrandDropdownMenu>
								{openDropDownMenu.brands ?
									(<Suspense fallback={<Loader />}>
										<BrandsDropdownMenu />
									</Suspense>) : null
								}
							</BrandDropdownMenu>
						</NavigationItemContainer>
					</MenuVisibility>
				)
			}
			if (label === 'Shop') {
				return (
					<MenuVisibility {...{ setOpenDropDownMenu, name: "Shop" }} key={label}>
						<NavigationItemContainer to={to} isExternalLink={isExternalLink} text={label} key={label} image={image} ref={setTabRef(idx)}>
							<ShopImgDropdownMenu>
								{openDropDownMenu.Shop ?
									(<Suspense fallback={<Loader />}>
										<ShopDropdownMenu />
									</Suspense>) : null
								}
							</ShopImgDropdownMenu>
						</NavigationItemContainer>
					</MenuVisibility>
				)
			}
			if (label === 'About') {
				return (
					<MenuVisibility {...{ setOpenDropDownMenu, name: "About" }} key={label}>
						<NavigationItemContainer to={to} isExternalLink={isExternalLink} text={label} key={label} image={image} ref={setTabRef(idx)}>
							<ImgDropdownMenu>
								{openDropDownMenu.About ?
									(<Suspense fallback={<Loader />}>
										<AboutDropdownMenu />
									</Suspense>) : null
								}
							</ImgDropdownMenu>
						</NavigationItemContainer>
					</MenuVisibility>
				)
			}
			if (label === 'Resources') {
				return (
					<MenuVisibility {...{ setOpenDropDownMenu, name: "Resources" }} key={label}>
						<NavigationItemContainer to={to} isExternalLink={isExternalLink} text={label} key={label} image={image} ref={setTabRef(idx)}>
							<ImgDropdownMenu>
								{openDropDownMenu.Resources ?
									(<Suspense fallback={<Loader />}>
										<ResourcesDropdownMenu />
									</Suspense>) : null
								}
							</ImgDropdownMenu>
						</NavigationItemContainer>
					</MenuVisibility>
				)
			}
		}
		if (label === 'Solutions') {
			return (
				<MenuVisibility {...{ setOpenDropDownMenu, name: "Solutions" }} key={label}>
					<NavigationItemContainer to={to} isExternalLink={isExternalLink} text={label} key={label} image={image} ref={setTabRef(idx)}>
						<SolutionsDropdownMenuContainer>
							{openDropDownMenu.Solutions ? (
								<Suspense fallback={<Loader />}>
									{isSmallScreen ? <SolutionsMenuResponsive /> : <SolutionsDropdownMenu />}
								</Suspense>
							) : null}
						</SolutionsDropdownMenuContainer>
					</NavigationItemContainer>
				</MenuVisibility>
			);
		}
		if (label === 'Services') {
			return (
				<MenuVisibility {...{ setOpenDropDownMenu, name: "Services" }} key={label}>
					<NavigationItemContainer to={to} isExternalLink={isExternalLink} text={label} key={label} image={image} ref={setTabRef(idx)}>
						<ServicesDropdownMenuContainer>
							{openDropDownMenu.Services ?
								(<Suspense fallback={<Loader />}>
									{isSmallScreen ? <ServicesMenuResponsive /> : <ServicesDropDownMenu />}
								</Suspense>) : null
							}
						</ServicesDropdownMenuContainer>
					</NavigationItemContainer>
				</MenuVisibility>
			);
		}

		return (
			<NavigationItemContainer to={to} isExternalLink={isExternalLink} text={label} key={label} image={image} ref={setTabRef(idx)}>
				<DropdownMenu>
					{subItems && subItems.map(ToMenuItem)}
				</DropdownMenu>
			</NavigationItemContainer>
		)
	}
	const tabComponents = tabDeclaration.map(ToMenu);
	const menuitems = !isMobile
		? tabDeclaration.slice(visibleTabCount, tabDeclaration.length).filter(c => c.to != '').map(ToMenuItem)
		: [...tabDeclaration.filter(b => b.label != 'Solutions'), { label: 'Contact Us', to: '/pages/contact/contact-us' }].map(ToMenuItem)
		const isTablet = window.innerWidth >= 426 && window.innerWidth <= 768;

	function MobileMenuDropdown({ label, icon, tabKey, items }) {
		return (
			<MobileMenuItem>
				<MobileMenusubItems onClick={() => toggleTab(tabKey)} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
					<span>
						<FontAwesomeIcon icon={icon} color="#DB1633" style={{ marginRight: '8px' }} />
						{label}
					</span>
					<span style={{ marginLeft: 'auto' }}>
						<FontAwesomeIcon icon={tabKey === subItemOpenTab ? faChevronUp : faChevronDown} />
					</span>
				</MobileMenusubItems>

				{subItemOpenTab === tabKey && (
					<SubItemUl isScrollable={items.length > 8}>
						{items.map(({ label, to, isExternalLink }, i) => (
							<li key={i}>
								{isExternalLink ? (
									<a
										href={to}
										target="_blank"
										rel="noopener noreferrer"
										onClick={() => setMobileMenuOpen(false)}
									>
										{label}
									</a>
								) : (
									<Link to={to} onClick={() => setMobileMenuOpen(false)}>
										{label}
									</Link>
								)}
							</li>
						))}
					</SubItemUl>
				)}
			</MobileMenuItem>
		);
	}


	// --------- MOBILE MENU RENDERING -----------
	function renderMobileMenu() {
		if (!isMobileMenuOpen) return null;

		return (
			<>
				<MobileMenuOverlay onClick={() => setMobileMenuOpen(false)} />
				<MobileSlideoutMenu>
					<MobileMenuCloseButton
						aria-label="Close menu"
						onClick={() => setMobileMenuOpen(false)}
					>
						&times;
					</MobileMenuCloseButton>

					<MobileMenuList>
						<MobileMenuDropdown
							label="Shop"
							icon={faShoppingCart}
							tabKey="shop"
							items={shopSubItems(categories)}
						/>
						<MobileMenuDropdown
							label="Services"
							icon={faWrench}
							tabKey="services"
							items={servicesSubItems}
						/>
						<MobileMenuDropdown
							label="Solutions"
							icon={faEye}
							tabKey="solutions"
							items={solutionsSubItems}
						/>
						<MobileMenuDropdown
							label="Industries"
							icon={faIndustry}
							tabKey="industries"
							items={industriesSubItems}
						/>
						<MobileMenuDropdown
							label="Brands"
							icon={faTrophy}
							tabKey="brands"
							items={brandsSubItems}
						/>
						<MobileMenuDropdown
							label="Resources"
							icon={faQuestionCircle}
							tabKey="resources"
							items={resourcesSubItems}
						/>
						<MobileMenuDropdown
							label="About"
							icon={faHome}
							tabKey="about"
							items={aboutSubItems}
						/>
						<MobileMenuDropdown
							label="Contact"
							icon={faUserPlus}
							tabKey="Contact"
							items={contactSubItems}
						/>

					</MobileMenuList>
				</MobileSlideoutMenu>
			</>
		);
	}

	return (
		<Nav location={location} {...props}>
			<HidePrint>
				{context.topAlert?.show && <TopAlert message={context.topAlert.message} close={context.removeTopAlert} />}
				<NavTop>
					<ReverseNavContainer>
						<AccountSection auth={auth} context={context} location={location} navigate={navigate} />
						<UserNameSection context={context} location={location} setShowAdvancedModal={setShowAdvancedModal} />
					</ReverseNavContainer>
				</NavTop>

				<NavBottom>
					<NavContainer ref={tabContainerRef}>
						<Row>
							<Link to="/">
								<AirlineLogoImg src="https://airlinemedia.airlinehyd.com/Airline's_logo/Airline-moving-logo.gif" width="100" alt="AirlineHyd.com" />
							</Link>
							<LinkContainer>
								{/* Desktop tab links */}
								{!isMobile ? tabComponents.slice(0, visibleTabCount) : null}

								{/* Hamburger for mobile */}
								{isMobile && (
									<button
										style={{
											background: "none",
											border: "none",
											color: "#222",
											fontSize: "1rem",
											padding: "0px 12px",
											cursor: "pointer"
										}}
										onClick={() => setMobileMenuOpen(true)}
										aria-label="Open menu"
									>
										<FontAwesomeIcon icon="bars" />
									</button>
								)}
								

								{/* Desktop overflow menu */}
								{!isMobile && visibleTabCount < tabDeclaration.length && (
									<Button ref={btnRef} onClick={e => setOverflowMenu(btnRef.current)} color="inherit" aria-label="More">
										<FontAwesomeIcon icon="ellipsis-h" />
									</Button>
								)}
								{/* Desktop only: MUI Menu */}
								{!isMobile && (
									<Menu
										disableScrollLock={true}
										onClick={() => setOverflowMenu(null)}
										MenuListProps={{ style: { backgroundColor: '#535353' } }}
										anchorEl={overflowMenu}
										open={!!overflowMenu}
										onClose={() => setOverflowMenu(null)}
									>
										{menuitems}
									</Menu>
								)}
							</LinkContainer>
						</Row>
						{!isMobile ? <ContactUs /> : null}
						<SearchBar context={context} location={location} navigate={navigate} />

					</NavContainer>
				</NavBottom>
				{/* Render mobile slide-out menu */}
				{isMobile && renderMobileMenu()}
				{(!context.userInfo || context.userInfo.isWebUser) && <NavGutter><FeedbackForm /></NavGutter>}
				{showAdvancedModal && (
					<Suspense fallback={<Loader />}>
						<AdvancedSearch open={showAdvancedModal} onClose={() => setShowAdvancedModal(false)} />
					</Suspense>
				)}
			</HidePrint>
		</Nav>
	);
}

